module.exports = __webpack_public_path__ + "img/2.78e97fd7.jpg";